jQuery(document).ready(function ($) { 

  // change dropdown value on making property type selection
  $(".type-select a").click(function () {
    $(this).parents(".dropdown").find('.dropdown-toggle').text($(this).text());
    $(this).parents(".dropdown").find('.dropdown-toggle').val($(this).text());

    $(this).parent().siblings('input[type=hidden]').val($(this).data('value')); // update hidden input with selection
  });

  // Enable clicking on property table row
  $('.property-table').on('click', 'tr[data-url]:not(.has-properties)', function (e) {
    e.preventDefault();
    window.location = $(this).data('url');
  });
  $('.property-table').on('click', 'tr.has-properties', function (e) {
    e.preventDefault();
    $('tr[id=properties_for_scheme_' + $(this).data('scheme') + ']').toggle().find('.scheme-properties-container').slideToggle();
  });

  // sticky nav bar
  var stickyHomeNav = jQuery(".header");
  var hero = jQuery('header').height();
  jQuery(window).scroll(function() {
      if( jQuery(this).scrollTop() > hero + 5 ) {
          stickyHomeNav.addClass("sticky-nav-bar");
      } else {
          stickyHomeNav.removeClass("sticky-nav-bar");
      }
  });

  /**
   * Function to open a bootstrap modal based on ID
   * @param int
   */
  function directLinkModal(hash) {
    $(hash).modal('show');
  }
  // pop the modal if the hash matches
  directLinkModal(window.location.hash);
  
});